import { DealStates, PricingType } from '~/constants';
import { formatDollars } from '~/utils/formatNumber';
import { display } from '~/utils/displayValues/common';
import { UnitDecimals } from '~/constants';
import { Project } from '~/types/project';
import getDisplayValueCosts from './getDisiplayValueCosts';

export default function epcCost(project: Project, projectCosts: any, permissions: any) {
  const projectCostsData = getDisplayValueCosts(project, projectCosts);
  const { data, overall, perWdc, perKwh, bid } = projectCostsData || {};

  const isInvestor = permissions.hasProjectInvestorAccess && !permissions.isAdmin;

  let hasEpcCost: boolean = true;
  if (data?.isRejectedBid) {
    hasEpcCost = false;
  }

  if (isInvestor && data?.isEpcProject && !bid) {
      hasEpcCost = false;
  }
  
  // if (isDeveloper && data?.isEpcProject && data?.isPendingBid) {
  //     hasEpcCost = false;
  // }

  if (!hasEpcCost) {
    return {
      perKwh: 'TBD',
      perWdc: 'TBD',
      total: 'TBD'
    };
  } else {

    // Show highlighted variant if project status is IN_DILIGENCE and pricing type is ACQUISITION
    const isHighlighted = project?.dealState >= DealStates.IN_DILIGENCE && project?.pricingType === PricingType.ACQUISITION;

    return {
      perKwh: display(perKwh?.epcCost && formatDollars(perKwh.epcCost, { dec: 2, default0: 'TBD' })),
      perWdc: display(perWdc?.epcCost && formatDollars(perWdc.epcCost, { dec: UnitDecimals.WDC, default0: 'TBD' })),
      total: display(overall?.epcCostTotal && formatDollars(overall.epcCostTotal, { dec: UnitDecimals.TOTAL, default0: 'TBD' })),
      isHighlighted
    };
  }
}